// 汎用的な施策データのインターフェース
export interface ShisakuItem {
    parent_cd?: number | null;
    seisaku_shisaku_cd: number;
    m_keikaku_id: string;
}

// 施策の葉ノードを取得する関数
export function getSeisakuLeaf<T extends ShisakuItem>(parentShisaku: T, shisakuList: T[]): T[] {
    const children = shisakuList.filter((shisaku) => shisaku.parent_cd && shisaku.parent_cd === parentShisaku.seisaku_shisaku_cd);

    // 子要素がない場合は葉とみなして自身を返す
    if (children.length === 0) {
        return [parentShisaku];
    }
    // 子要素がある場合は再帰的に取得
    return children.flatMap((child) => getSeisakuLeaf(child, shisakuList));
}

// 施策の葉ノードから親ノードまでを取得する関数
export function getSeisakuChainFromLeaf<T extends ShisakuItem>(leaf: T, shisakuList: T[]): T[] {
    const parent = shisakuList.find(
        (shisaku) => shisaku.seisaku_shisaku_cd === leaf.parent_cd && leaf.m_keikaku_id === shisaku.m_keikaku_id
    );
    if (!parent) {
        return [leaf];
    }
    // 親ノードがある場合は再帰的に取得し、親ノードを先頭で並べる
    return [...getSeisakuChainFromLeaf(parent, shisakuList), leaf];
}
